/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SupplierPaymentService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/CashPayment",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getCustomData(params) {
    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
      select: params.select,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async cancelPayment(payload) {
    var url = "api/CashPayment/Cancel";

    return await ApiService.post(url, payload);
  },

  async saveSupplierPayment(payload) {
    var url = `api/Save_CashPayment`;
    return await ApiService.post(url, payload);
  },

  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AP'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AP'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getSupplierInvoiceDetails(params) {
    const requestScreenData = {
      url: "api/SupplierInvoice",
      filter: params.filter,
      select: params.select,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { SupplierPaymentService };
